
import {
  formatDateNormal,
  formatDateNumber
} from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { UrgentDeliveryManagementController } from "@/app/ui/controllers/UrgentDeliveryManagementController";
import { OptionsClass } from "@/domain/entities/MainApp";
import { ApiStateData } from "@/domain/entities/Api";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import {
  UrgentDeliveryManagementDetailData,
  UrgentDeliveryManagementPODData,
  UrgentDeliveryManagementPODListRequest,
  UrgentDeliveryManagementPODListRequestDownload,
  UrgentDeliveryManagementPODSummaryRequest,
  LastLocationOption,
} from "@/domain/entities/UrgentDeliveryManagement";
import { Options, Vue } from "vue-class-component";
import Detail from "../detail.vue";
import FilterSectionPod from "./filter-section.vue";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

@Options({
  components: {
    Detail,
    FilterSectionPod
  }
})
export default class UrgentPOD extends Vue {
  controller = UrgentDeliveryManagementController;
  parameters = {
    search: "",
    flags: "",
    productType: new OptionsClass(),
    startDate: new Date(
      new Date(new Date().setMonth(new Date().getMonth() - 1))
    ) as Date | null,
    endDate: new Date() as Date | null,
    cityCode: new OptionsClass(),
    hubId: new OptionsClass(),
    sortBy: "",
    sortDirection: ""
  };
  modalDetail = false;
  apiDetailData = new ApiStateData();
  urgentDeliveryManagementDetailData = new UrgentDeliveryManagementDetailData();

  get columns() {
    return [
      {
        name: this.$t("urgentDeliveryManagement.pod.columnNo"),
        styleHead: "w-12 text-left",
        render: (item: UrgentDeliveryManagementPODData, i: number) =>
          `<span class="${
            this.getStyleByFlag(item.pdFlag).class
          } font-normal overflow-ellipisis text-left text-black-lp-300 whitespace-nowrap">${i +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</span>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnNoStt"),
        styleHead: "w-44 text-left ",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left flex flex-col gap-1 text-sm text-black-lp-100">
          <div>
            ${item.pdSTTNo}
          </div>
          ${
            item.pdFlag
              ? `<div class="flex flex-row gap-1">
            <img src="${require(`@/app/ui/assets/svg/${
              this.getStyleByFlag(item.pdFlag).icon
            }`)}" class="text-red-lp-100" width="16" />
            <div class="font-medium text-sm ${
              this.getStyleByFlag(item.pdFlag).textClass
            }">${item.pdFlag}</div>
          </div>`
              : ""
          }
        </div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnDeliveryType"),
        styleHead: "w-36 text-left",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">
          ${item.sttDeliveryType} 
        </div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnReason"),
        styleHead: "text-left w-50",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${item.pdReason}</div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnUnprocessed"),
        styleHead: "text-left w-50",
        sortBy: "pd_aging_days",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${this.getAgingDaysFormatted(
            item.pdAgingDays
          )}</div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnLastStatus"),
        styleHead: "text-left w-40",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${item.sttLastReturnId}</div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnProductType"),
        styleHead: "text-left w-40",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${item.pdProductType ||
            "-"}</div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnDexAttempt"),
        styleHead: "text-left w-48",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${item.deliveryDEXAttempt}</div>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnLastLocation"),
        styleHead: "text-left w-60",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">
            ${item.lastLocationLabel}
          </div>
          <span class="text-xs text-gray-lp-300">
            Station: ${item.stationBucket || "-"}
          </span>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnRequestDate"),
        styleHead: "text-left w-60",
        sortBy: "pd_created_at",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${item.formatCreatedAt}</div> <span class="text-xs text-gray-lp-300">${item.createdBy}</span>`
      },
      {
        name: this.$t("urgentDeliveryManagement.pod.columnBkdDate"),
        styleHead: "text-left w-60",
        sortBy: "stt_booked_at",
        render: (item: UrgentDeliveryManagementPODData) =>
          `<div class="overflow-ellipsis text-left font-normal text-sm">${item.formatBookedAt}</div> <span class="text-xs text-gray-lp-300">${item.bookedBy}</span>`
      }
    ];
  }

  get pagination() {
    return this.controller.paginationData;
  }

  get urgentDeliveryManagementPODSummary() {
    return this.controller.PODSummary;
  }

  mounted(): void {
    this.fetchList(true);
    this.fetchPODSummary();
    this.controller.resetLastLocationOptions();
    this.controller.getLastLocationOptions();
  }

  get filterOptions() {
    return [
      new OptionsClass({
        name: this.$t("urgentDeliveryManagement.pod.filterUrgent"),
        value: "Kiriman Penting"
      }),
      new OptionsClass({
        name: this.$t("urgentDeliveryManagement.pod.filterOverSla"),
        value: "Lewat batas SLA"
      }),
      new OptionsClass({
        name: this.$t("urgentDeliveryManagement.pod.filterRedelivery"),
        value: "Delivery Ulang"
      })
    ];
  }

  productTypeOptions = [
    "VIPPACK",
    "BOSSPACK",
    "REGPACK",
    "MINIPACK",
    "BIGPACKFAST",
    "JAGOPACK",
    "BIGPACK",
    "INTERMAXXI",
    "INTERPACK",
    "ONEPACK"
  ].map((pd) => new OptionsClass({ name: pd, value: pd }));

  get lastLocationOptions(): LastLocationOption[] {
    return this.controller.lastLocationOptions;
  }

  fetchList(reset = false): void {
    if (reset) {
      this.controller.paginationData.page = 1;
    }

    this.controller.getPODList(
      new UrgentDeliveryManagementPODListRequest({
        sttNo: this.parameters.search,
        page: this.controller.paginationData.page,
        limit: this.controller.paginationData.limit,
        flags: this.parameters.flags,
        productType: this.parameters.productType.value,
        startDate: this.parameters.startDate
          ? formatDateNumber(this.parameters.startDate)
          : "",
        endDate: this.parameters.endDate
          ? formatDateNumber(this.parameters.endDate)
          : "",
        cityCode: this.parameters.cityCode.value,
        hubId: this.parameters.hubId.value,
        sortColumn: this.parameters.sortBy,
        sortBy: this.parameters.sortDirection
      })
    );
  }

  onSearch(value: string) {
    if (!value.length || value.length >= 3) {
      this.parameters.search = value;
      this.fetchList(true);
    }
  }

  onFilter(data: OptionsClass, type: string): void {
    Object.assign(this.parameters, { [type]: data });
    this.fetchList(true);

    if (type === "productType") {
      this.fetchPODSummary();
    }
  }

  onFilterFlag(data: OptionsClass) {
    const flagsArray = this.parameters.flags.length
      ? this.parameters.flags.split(",")
      : [];
    const flagIndex = flagsArray.findIndex((el) => el === data.value);

    if (flagIndex !== -1) {
      flagsArray.splice(flagIndex, 1);
    } else {
      flagsArray.push(data.value);
    }

    this.parameters.flags = flagsArray.join(",");
    this.fetchList(true);
  }

  getAgingDaysFormatted(pdAgingDays: number): string {
    return pdAgingDays > 0
      ? `${pdAgingDays} ${this.$t(
          "urgentDeliveryManagement.formatAgingDays.days"
        )}`
      : (this.$t("urgentDeliveryManagement.formatAgingDays.today") as string);
  }

  filterCounter(value: string) {
    switch (value) {
      case this.$t("urgentDeliveryManagement.pod.filterUrgent"):
        return `(${this.urgentDeliveryManagementPODSummary.prioritShipment})`;
      case this.$t("urgentDeliveryManagement.pod.filterOverSla"):
        return `(${this.urgentDeliveryManagementPODSummary.overSlaLimit})`;
      case this.$t("urgentDeliveryManagement.pod.filterRedelivery"):
        return `(${this.urgentDeliveryManagementPODSummary.redelivery})`;
    }
  }

  onClear(): void {
    this.parameters.search = "";
    this.fetchList(true);
  }

  getStyleByFlag(
    flag: string
  ): {
    class: string;
    icon: string;
    textClass: string;
  } {
    if (
      flag
        .toLowerCase()
        .includes(this.$t("urgentDeliveryManagement.pod.flagUrgentDeliver"))
    ) {
      return {
        class: "",
        icon: "ics_o_urgent_delivery.svg",
        textClass: "text-red-lp-100"
      };
    }
    if (
      flag
        .toLocaleLowerCase()
        .includes(this.$t("urgentDeliveryManagement.pod.flagOverSlaLimit"))
    ) {
      return {
        class: "",
        icon: "ics_o_clock_warning_red.svg",
        textClass: "text-red-lp-100"
      };
    } else {
      return {
        class: "delivery-proccess",
        icon: "ics_o_delivery_process.svg",
        textClass: "text-gray-lp-600"
      };
    }
  }

  get emptyStateData(): {
    headerMessage: string;
    message: string;
    icon: string;
  } {
    const hasFilter =
      this.parameters.search.length ||
      this.parameters.startDate ||
      this.parameters.endDate;

    if (hasFilter) {
      return {
        headerMessage: this.$t(
          "urgentDeliveryManagement.empty.filterNotFound"
        ) as string,
        message: this.$t(
          "urgentDeliveryManagement.empty.filterNotFoundMessage"
        ) as string,
        icon: "noData_filter"
      };
    } else {
      return {
        headerMessage: this.$t(
          "urgentDeliveryManagement.empty.header"
        ) as string,
        message: this.$t("urgentDeliveryManagement.empty.message") as string,
        icon: "noData_empty"
      };
    }
  }

  async onDownload() {
    await this.controller.downloadUrgentPODList(
      new UrgentDeliveryManagementPODListRequestDownload({
        sttNo: this.parameters.search,
        startDate: this.parameters.startDate
          ? formatDateNumber(this.parameters.startDate)
          : "",
        endDate: this.parameters.endDate
          ? formatDateNumber(this.parameters.endDate)
          : "",
        cityCode: this.parameters.cityCode.value,
        hubId: this.parameters.hubId.value,
        flags: this.parameters.flags,
        productType: this.parameters.productType.value,
        sortColumn: this.parameters.sortBy,
        sortBy: this.parameters.sortDirection
      })
    );
  }

  async fetchPODSummary() {
    MainAppController.showLoading();
    try {
      const params = new UrgentDeliveryManagementPODSummaryRequest({
        productType: this.parameters.productType.value,
        startDate: this.parameters.startDate ? this.$moment(this.parameters.startDate).format("YYYY-MM-DD") : "",
        endDate: this.parameters.startDate ? this.$moment(this.parameters.endDate).format("YYYY-MM-DD") : "",
        cityCode: this.parameters.cityCode.value,
        hubId: this.parameters.hubId.value,
      })

      await UrgentDeliveryManagementController.getPODSummary(params);
    } catch (error) {
      MainAppController.closeLoading();
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          type: "client-error",
          title: this.$t(
            "urgentDeliveryManagement.error.getPODSummaryFailed"
          ) as string,
          onClose: () => {
            MainAppController.closeErrorMessage();
          }
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async goToDetail(item: UrgentDeliveryManagementPODData) {
    await this.getDetailData(item.pdId);
  }

  closeDetail() {
    this.modalDetail = false;
  }

  async getDetailData(id: number) {
    MainAppController.showLoading();
    try {
      this.urgentDeliveryManagementDetailData = await UrgentDeliveryManagementController.getPriorityDeliveryManagementDetail(
        id
      );
      this.modalDetail = true;
      this.apiDetailData.errorType = "";
    } catch (error) {
      MainAppController.closeLoading();
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          type: "client-error",
          title: this.$t(
            "urgentDeliveryManagement.error.getDetailFailed"
          ) as string,
          onClose: () => {
            MainAppController.closeErrorMessage();
          }
        })
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  onSort(sort: { sortBy: string; sortDirection: "ASC" | "DESC" }) {
    this.parameters.sortBy = sort.sortBy;
    this.parameters.sortDirection = sort.sortDirection;
    this.fetchList(true);
  }

  setPeriode(value: Array<Date | null>): void {
    this.parameters.startDate = value[0];
    this.parameters.endDate = value[1];
    if (value[0] && value[1]) {
      this.fetchList(true);
      this.fetchPODSummary();
    }
  }

  onApplyFilter(payload: {
    productType: OptionsClass;
    startDate: Date | null;
    endDate: Date | null;
    lastLocations?: { cityCodes: string[]; hubIds: number[] };
  },
    type: string
  ) {
    this.parameters.productType = payload.productType;
    this.parameters.startDate = payload.startDate;
    this.parameters.endDate = payload.endDate;

    if (payload.lastLocations) {
      this.parameters.cityCode = new OptionsClass({
        value: payload.lastLocations.cityCodes.join(",")
      });
      this.parameters.hubId = new OptionsClass({
        value: payload.lastLocations.hubIds.map(String).join(",")
      });
    }

    this.fetchList(true);

    if (type === 'productType' || payload.lastLocations) {
      this.fetchPODSummary();
    }
  }

  onResetFilter() {
    this.parameters.productType = new OptionsClass();
    this.parameters.startDate = null;
    this.parameters.endDate = null;
    this.parameters.flags = "";
    this.parameters.cityCode = new OptionsClass();
    this.parameters.hubId = new OptionsClass();

    this.fetchList(true);
    this.fetchPODSummary();
  }
}
